<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout justify-space-between row wrap v-if="header.collectiveConvention">
        <v-flex v-for="(item, i) in informations" :key="i" :class="item.class">
          <v-list three-line light class="py-0 elevation-2">
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="font-weight-bold">{{item.title}}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{item.subtitle}}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{item.value | currency}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
      
      <v-divider class="mt-3"/>
      <v-form ref="form" v-model="formValid">
        <v-layout justify-space-between row wrap>
          <v-flex xs12 pa-0>
            <v-subheader>Setor da Prestação do Serviço</v-subheader>
            <v-radio-group v-model="sectorType" row @change="changeSector" :readonly="budgetFinalized">
              <v-radio label="Outro Setor" value="OTHER"></v-radio>
              <v-radio label="Setor SEDE" value="SEDE"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12>
            
              <v-layout justify-space-between row wrap>
                <v-flex xs12 sm6>
                  <v-text-field type="text" :rules="ruleGeneric" label="Setor" 
                  v-model="header.deliveryAddress.sector" box :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-text-field type="text" :rules="ruleGeneric" label="CEP"   
                  v-model="header.deliveryAddress.cep" box  @input="findAddressByCep" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field type="text" :rules="ruleGeneric" label="Logradouro"  
                  v-model="header.deliveryAddress.addressType" box :disabled="isSearchingAddress" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-text-field type="text" :rules="ruleGeneric" label="Número" 
                  v-model="header.deliveryAddress.number" box :disabled="isSearchingAddress" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field type="text"  label="Complemento" 
                  v-model="header.deliveryAddress.complement" box :disabled="isSearchingAddress" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field type="text" :rules="ruleGeneric" label="Bairro" 
                  v-model="header.deliveryAddress.district" box :disabled="isSearchingAddress" :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-autocomplete label="Município" :rules="ruleGeneric"  
                    v-model="header.deliveryAddress.cityOfService" :items="cities"
                    :item-text="cityText" 
                    return-object 
                    dense solo box 
                    :disabled="isSearchingAddress" 
                    :readonly="budgetFinalized">
                    <template v-slot:append-outer v-if="!budgetFinalized">
                      <v-tooltip
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" @click="buttonAddNewCity">add</v-icon>
                        </template>
                        Cadastrar nova Cidade!
                      </v-tooltip>
                    </template> 
                  </v-autocomplete>
                </v-flex>
              </v-layout>
          
          
          </v-flex>
        </v-layout>
        <v-divider class="pb-3"/>
        <v-layout justify-space-between row wrap>
          <v-flex xs12 sm4>
            <v-autocomplete label="Unidade de medida" :rules="ruleGeneric" :items="unitsOfMeasurement" 
              v-model="header.unitOfMeasurement"
              box :readonly="budgetFinalized"></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4>
            <v-autocomplete label="Descrição do Serviço" :rules="ruleGeneric" :items="offices" 
              item-text="description" return-object box
              v-model="header.office" dense :readonly="budgetFinalized"></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field type="number" min="1" 
            label="Quantidade de empregados estimada total a contratar"
            :rules="ruleGeneric" :readonly="budgetFinalized"
            v-model="header.numberOfEmployees" box></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-autocomplete label="Ano do acordo, convenção ou dissído coletivo" 
              :items="agreementsYear" :rules="ruleGeneric" persistent-hint :readonly="budgetFinalized"
              item-text="year" v-model="header.collectiveConvention" item-value="_id" dense box
              :disabled="hasServiceStationGratification"  :hint="msgCollectiveConvention"
              >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-autocomplete label="Categoria profissional" :items="agreementsYearSelectedItems"
              :item-text="occupationName" :hint="professionalCategoryHint" 
              v-model="header.professionalCategory" dense return-object :readonly="budgetFinalized"
              persistent-hint box :disabled="!header.collectiveConvention" :rules="ruleGeneric">
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-text-field label="Carga Horária"  v-model="header.additionalInfo" box :readonly="budgetFinalized">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-text-field label="Data base da categoria" v-model="header.dataBaseOfTheCategory" 
            box type="date" :rules="ruleGeneric" :readonly="budgetFinalized">
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea v-model="header.mainNotes" :rules="ruleGeneric" label="Notas Principais" rows="5" box :readonly="budgetFinalized"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-textarea v-model="header.complementariesNotes" :rules="ruleGeneric" 
            label="Notas Complementares" rows="5" box :readonly="budgetFinalized"></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>

    <!-- DIALOGS ADD NEW REGISTERS 
    <v-dialog v-model="showDialogAddNewFunction" max-width="500">
      <form-occupation></form-occupation>
    </v-dialog>-->
    <v-dialog v-model="showDialogAddNewProfessionalCategory" max-width="500">
      <form-professional-category :year-convention-selected="header.collectiveConvention"></form-professional-category>
    </v-dialog>

    <v-dialog v-model="showDialogAddNewCity" max-width="500">
      <form-city></form-city>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.visible"
      :color="snackbar.color"
      multi-line
      :timeout="snackbar.timeout"
      vertical
      right
      button
    >
      <strong>{{snackbar.title}}</strong> {{ snackbar.subtitle }}
      <v-btn
        dark
        flat
        @click="snackbar.visible = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  //Components
  import FormCity from "../../components/budget/FormCity";
  import FormProfessionalCategory from "../../components/budget/FormProfessionalCategory";
  //Data
  import SheetDefaultData from '../../data/sheet/SheetDefaultData';
  //Libs
  import {mapState} from "vuex";
  //Services
  import CityService from "../../service/CityService.js";
  import CollectiveConventionService from "../../service/CollectiveConventionService.js";
  import OfficceService from "../../service/OfficceService.js";
  //Utils
  import UtilFormatter from "../../utils/UtilFormatter.js";  
  import Rules from "../../utils/RulesToForms"
  export default {
    components: {
      FormProfessionalCategory,
      FormCity
    },
    data() {
      return {
        agreementsYear: [],
        agreementsYearSelectedItems:[],
        allowChange: true,
        cities: [],
        formValid:true, 
        isSearchingAddress: false,
        offices: [],
        ruleGeneric:[ Rules.ruleToCheckIfTheValuesInTheFields],
        snackbar: {
          visible: false,
          title: "",
          subtitle: "",
          color: "",
          timeout: 6000
        },
        showDialogAddNewCity: false,
        showDialogAddNewFunction: false,
        showDialogAddNewProfessionalCategory: false,
        unitsOfMeasurement: ["Posto de Serviço", "M²"],
        utilFormatter: UtilFormatter,
      };
    },
    
    methods: {
      buttonAddNewCity() {
        this.showDialogAddNewCity = true;
      }, //buttonAddNewCity()*/
      // AÇÕES DE BOTÕES QUE CHAMAM COMPONENTES //
      buttonAddNewFunction() {
        this.showDialogAddNewFunction = true;
      }, //buttonAddNewFunction()
      buttonAddNewProfessionalCategory() {
        this.showDialogAddNewProfessionalCategory = true;
      }, //buttonAddNewProfessionalCategory()*/
      async changeCollectiveConvention(collectiveConvention){
        if(!this.header.collectiveConvention)
          this.agreementsYearSelectedItems = new Array()
        
        this.agreementsYearSelectedItems = collectiveConvention.items
        
        this.header.minimalSalary         = collectiveConvention.minimalSalary
        this.header.dataBaseOfTheCategory = this.utilFormatter.formatDateUS(collectiveConvention.dataBaseOfTheCategory
            .substr(0, 10))
        for (let j = 0; j < collectiveConvention.items.length; j++) {
          const element = collectiveConvention.items[j]
          if(this.header.professionalCategory.occupation.code === element.occupation.code){
            this.header.professionalCategory.basicSalary = element.basicSalary
            this.header.professionalCategory.costs       = element.costs
            j = collectiveConvention.items.length
          }
        }
      },
      async changeOfficces() {
        try {
          this.offices = await OfficceService.getAll();
          this.offices.sort();
        } catch (error) {}
      }, //changeOfficces()

      async changeSector(){
        if(this.sectorType == "SEDE"){
          this.header.deliveryAddress = this.sedeAddress()
        }else{
          let deliveryAddress = {
              sectorType    : "OTHER", 
              cityOfService : {},
              complement    : "",
              district      : "",
              number        : "",
              addressType   : "",
              cep           : "",
              sector        : ""
          }

          this.header.deliveryAddress = deliveryAddress
        }
      },
      cityText: item => `${item.name} - ${item.state} (${item.uf})`,
      async findAddressByCep() {
        try {
          if (this.header.deliveryAddress.cep && this.header.deliveryAddress.cep.length == 8) {
            this.isSearchingAddress = true
            let address = await UtilService.findAddressByCep(this.header.deliveryAddress.cep);
            
            let founded = this.cities.find(x => x.name == address.city); 
            
            if (founded) {
              this.header.deliveryAddress.addressType         = address.addressType
              this.header.deliveryAddress.number              = address.number
              this.header.deliveryAddress.complement          = address.complement
              this.header.deliveryAddress.district            = address.district
              this.header.deliveryAddress.cityOfService       = founded
            }else{
              this.snackbar.color   = "error"
              this.snackbar.title   = "Cidade não cadastrada!"
              this.snackbar.subtitle= "Cadastre-a antes de continuar"
              this.snackbar.visible = true
              this.snackbar.timeout = 500000
              this.header.deliveryAddress.cep           = ""
              this.header.deliveryAddress.number        = ""
              this.header.deliveryAddress.complement    = ""
              this.header.deliveryAddress.district      = ""
              this.header.deliveryAddress.cityOfService = ""
              this.header.deliveryAddress.addressType   = ""
            }
          }
        } catch (error) {
          this.snackbar.color   = "error"
          this.snackbar.title   = "CEP inválido!"
          this.snackbar.subtitle= "Repita a operação"
          this.snackbar.timeout = 6000
          this.snackbar.visible = true
        } finally {
          this.isSearchingAddress = false;
        }
      },
      async init() {
        await this.fillCitiesTable();
        await this.fillAgreementsData();
        await this.fillAgreementsYear();
        await this.changeOfficces();
      }, //init()

      async fillAgreementsYear(){
        try {
          this.agreementsYear = await CollectiveConventionService.getAll();
        } catch (error) {
          console.log(error);
        }
      },
      async fillAgreementsData(){
        if(!this.header.collectiveConvention)
          this.agreementsYearSelectedItems = new Array()
        else{
          let selected = await CollectiveConventionService.getById(this.header.collectiveConvention)
        
          if(selected){
            this.agreementsYearSelectedItems = selected.items
          }else{
            this.agreementsYearSelectedItems = new Array()
          }
        }
      },

      async fillCitiesTable() {
        try {
          this.cities = await CityService.getAll();
        } catch (error) {
          console.log(error);
        }
      },      
      findCityByNameAndState(address){
        for (let i = 0; i < this.cities.length; i++) {
          if(address.city.toUpperCase() == this.cities[i].name.toUpperCase() && address.state.toUpperCase() == this.cities[i].uf.toUpperCase()){
            return this.cities[i];
          }
        }
      },
      
      occupationName: item =>`${item.occupation.name}`,
      sedeAddress(){
        let address = {sectorType: "SEDE", sector:"SEDE"}
        if(this.budget && this.budget.client && this.budget.client.address){
          
          address.cityOfService       = this.findCityByNameAndState(this.budget.client.address)
          address.complement          = this.budget.client.address.complement
          address.district            = this.budget.client.address.district
          address.number              = this.budget.client.address.number
          address.addressType         = this.budget.client.address.addressType
          address.cep                 = this.budget.client.address.cep
        } else{
          let address = {sectorType: "OTHER", sector:"Outro"}
        }
        
        return address
      },
      async setSheetHeader() {
        let sheet = this.analyticalWorksheet
        if(sheet.header != this.header){
          sheet.header = Object.assign({}, this.header)
          await this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);
        }
      },

      /**
       * @returns {Boolean}
       */
      startValidationInVForm(){
        /* 
          O metodo validate() do v-form percorre em seus campos internos
          e verifica se aqueles que possuem rules cumprem com o esperado.
          Esse metodo retorna um boolean de acordo com o resultado das
          validaçẽos e se houver falhas ele pinta o campo
        */
        return this.$refs.form.validate();
      }
    },

    computed: {
      hasServiceStationGratification(){
        return this.analyticalWorksheet.moduleOne &&
              this.analyticalWorksheet.moduleOne.serviceStationGratification &&
              this.analyticalWorksheet.moduleOne.serviceStationGratification.length > 0
      },
      header(){
        this.init()
        let headerDefault = SheetDefaultData.getHeader()
        
        if(!this.analyticalWorksheet.header.professionalCategory)
          this.analyticalWorksheet.header.professionalCategory = headerDefault.professionalCategory

        if(!this.analyticalWorksheet.header.deliveryAddress || this.analyticalWorksheet.header.deliveryAddress.sectorType === ""){
          this.analyticalWorksheet.header.deliveryAddress = this.sedeAddress()
        }

        this.sectorType     = this.analyticalWorksheet.header.deliveryAddress && this.analyticalWorksheet.header.deliveryAddress.sectorType ? this.analyticalWorksheet.header.deliveryAddress.sectorType : null
        
        return this.analyticalWorksheet.header
      },
      informations(){
        return [
          {
            class: "xs12 md6",
            title: "Salário Mínimimo Nacional",
            subtitle: "De acordo com a Convenção Coletiva Cadastrada",
            value: this.header.minimalSalary
          },
          {
            class: "xs12 md6",
            title: "Salário Normativo da Categoria Profissional",
            subtitle: "De acordo com a Convenção Coletiva Cadastrada",
            value: this.header.professionalCategory.basicSalary 
          }        
        ]
      },
      msgCollectiveConvention(){
        return this.hasServiceStationGratification ? "Remova os adicionais de posto de serviço caso deseje alterar" : ""
      },
      professionalCategoryHint(){
        return this.header.professionalCategory && this.header.professionalCategory.occupation && this.header.professionalCategory.occupation.code ? `CBO: ${this.header.professionalCategory.occupation.code.substring(0,4)}-${this.header.professionalCategory.occupation.code.substring(4,6)}` : "CBO:"
      },
      ...mapState({analyticalWorksheet: state => state.budget.analyticalWorksheet}),
      ...mapState({budget: state => state.budget.budget}),
      ...mapState({budgetFinalized: state => state.budget.budgetFinalized})
    },
    beforeMount(){
      this.init();
    },
    created() {

      // Salvando instancia deste componente
      let thiss = this;

      // Gerando os listeners para EventHub //
      // FUNCTION

      this.$eventHub.$on("cancelDialogAddNewFunction", _ => {
        thiss.showDialogAddNewFunction = false;
      });

      this.$eventHub.$on("savedNewFunction", _ => {
        thiss.offices = [];
        thiss.changeOfficces();
        thiss.showDialogAddNewFunction = false;
      });


        //this.$ref.product
      // PROFESSIONAL CATEGORY
      this.$eventHub.$on("cancelDialogAddNewOccupation", _ => {
        thiss.showDialogAddNewProfessionalCategory = false;
      });

      this.$eventHub.$on("savedNewOccupation", _ => {
        thiss.showDialogAddNewProfessionalCategory = false;
      });

      this.$eventHub.$on("savedNewCity", _ => {
        thiss.fillCitiesTable();
        thiss.showDialogAddNewCity = false;
        thiss.snackbar.color   = "success"
        thiss.snackbar.title   = "Cidade Cadastrada com Sucesso"
        thiss.snackbar.subtitle= ""
        thiss.snackbar.timeout = 6000
        thiss.snackbar.visible = true
      });

      this.$eventHub.$on("newCityNotSaved", _ => {
        thiss.fillCitiesTable();
        thiss.showDialogAddNewCity = false;
        thiss.snackbar.color   = "error"
        thiss.snackbar.title   = "Não foi possível realizar essa operação!"
        thiss.snackbar.subtitle= "Tente Novamente"
        thiss.snackbar.timeout = 500000
        thiss.snackbar.visible = true
      });

      this.$eventHub.$on("cancelDialogAddNewCity", _ => {
        thiss.fillCitiesTable();
        thiss.showDialogAddNewCity = false;
      });
    }, //created
    
    watch: {
      header: {
        handler: function(newValue, oldValue) {
          this.setSheetHeader()
        },
        deep: true
      },

      'header.collectiveConvention': {
        handler: async function (newValue, oldValue) {
          console.log(this.allowChange)
          if(!this.allowChange){
            this.allowChange = true
            return
          }
          if(newValue && newValue != oldValue){
            let convention = await CollectiveConventionService.getById(newValue);
            
            if(confirm("Os valores finais das funções serão alterados com base na nova convenção")){
              this.changeCollectiveConvention(convention)
            }else{
              this.header.collectiveConvention = oldValue
              this.allowChange = false
              return
            }
          }
        },
        deep: true
      }
   }
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/budget/TabHeader.vue